<template>
  <div class="sc__transition">
    <slot name="transitionHeroImage">
      <TheIntroHero />
    </slot>

    <div class="sc__transition__content container">
      <div class="sc__transition__heading">
        <h1 v-if="pageHeading">
          {{ pageHeading }}
        </h1>
        <p v-if="pageSubHeading">
          {{ pageSubHeading }}
        </p>
      </div>

      <div class="sc__transition__product-search">
        <slot name="transitionProductSearch" />

        <div class="sc__transition__product-search__info">
          <slot name="transitionProductSearchHelpAccordion">
            <ScAccordion
              :cta="translations.transition.productSearchHelpMessageLabel"
            >
              {{ translations.transition.productSearchHelpMessageText }}
              <a
                :href="translations.transition.productSearchHelpMessageUrl.link"
                target="_blank"
              >
                {{ translations.transition.productSearchHelpMessageUrl.text }}
              </a>
            </ScAccordion>
          </slot>
        </div>
      </div>

      <div class="sc__transition__supplemental-content">
        <slot name="supplemental" />
      </div>
    </div>
  </div>
</template>

<script src="./index.js"></script>

<style lang="scss">
  @import './style.scss';
</style>
